import { memo } from 'react';
import css from './index.module.scss';
import { Typography, Button } from '@components/base';
import { BoxContainer } from '@components/common';
import { IQuoteEnquiry } from '@helpers/types/add-order';

interface OrderPreviewContainerProps {
  orderType: string;
  orderNumber: string;
  quoteEnquiry: IQuoteEnquiry | null;
}

const OrderPreviewContainer = (props: OrderPreviewContainerProps) => {
  const { orderType, orderNumber, quoteEnquiry } = props;
  return (
    <BoxContainer title="Order Preview" className={css.mainWrapper}>
      <div className={css.boxWrapper}>
        <Typography variant="pdoc">Type of Order</Typography>
        <div className={css.rowWrapper}>
          <div className={css.columnWrapper}>
            <Typography variant="ptext">Order Type</Typography>
            <Typography variant="p">{orderType}</Typography>
          </div>
          <div className={css.columnWrapper}>
            <Typography variant="ptext">Order Number</Typography>
            <Typography variant="p">
              {orderNumber ? orderNumber : 'This will be assigned once order is created'}
            </Typography>
          </div>
          <div className={css.columnWrapper}>
            <Typography variant="ptext">Reference Quote</Typography>
            <Typography variant="p">
              {quoteEnquiry ? (
                <Button
                  variant="text"
                  className={css.quoteLink}
                  onClick={() => window.open(`/quote/detail/${quoteEnquiry.enquiry_id}`, '_blank')}
                >
                  {quoteEnquiry.readable_enquiry_number}
                </Button>
              ) : (
                '-'
              )}
            </Typography>
          </div>
        </div>
      </div>
    </BoxContainer>
  );
};

export default memo(OrderPreviewContainer);
